import React from 'react';
import userContext from '../../context/user/userContext';
import { useContext } from 'react';
const SidebarProfile = () => {
  const {userState, updateUserState} = useContext(userContext)

  return (
    <div className="profile__sidebar">
      <div className="space-y-40">
        <div className="space-y-10">
          <h5>About me</h5>
          <div className="box space-y-20">
            <p>
              {userState.profile.bio}
            </p>
            <div className="row">
              <div className="col-6">
                <span className="txt_sm color_text">Collections</span>
                <h4>10</h4>
              </div>
              <div className="col-6">
                <span className="txt_sm color_text">Creations</span>
                <h4>10</h4>
              </div>
            </div>
          </div>
        </div>
        <div className="space-y-10">
          <h5>Follow me</h5>
          <div className="box">
            <ul className="social_profile space-y-10 overflow-hidden">
              <li>
              <a href="https://www.facebook.com/" rel="noreferrer"  target="_blank">
                  <i className="ri-facebook-line" />
                  <span className="color_text">facebook/</span>
                  @{userState.profile.facebookUsername}
                </a>
              </li>
              <li>
              <a href="https://www.twitter.com/" rel="noreferrer"  target="_blank">
                  <i className="ri-facebook-line" />
                  <span className="color_text">twitter/</span>
                  @{userState.profile.twitterUsername}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <p className="text-center txt_sm mt-20 color_text">Since 2021</p>
    </div>
  );
};

export default SidebarProfile;
